import { CHARGEBACK_DETAIL_LABEL_CLASS } from '../../constants/chargebackDetailConstants'
import { display } from '../../utils/chargebackDetailFormatters'

export function ChargebackDetailField({
  label,
  children,
}: {
  label: string
  children: React.ReactNode
}) {
  return (
    <label className="space-y-2">
      <span className={CHARGEBACK_DETAIL_LABEL_CLASS}>{label}</span>
      {children}
    </label>
  )
}

export function ChargebackDetailRow({ label, value }: { label: string; value: unknown }) {
  return (
    <div className="space-y-1">
      <dt className={CHARGEBACK_DETAIL_LABEL_CLASS}>{label}</dt>
      <dd className="text-sm font-semibold text-slate-800">{display(value)}</dd>
    </div>
  )
}
